import { I18n } from "@ies/starling_intl";
import { UserInfo } from "@/models/common";
import { Result } from "@arco-design/web-react";
import React, { lazy } from "react";
import { Switch, Route } from "react-router-dom";
import RO_PIC from "@/pages/RO/index_pic";
// 接口测试自动化
const InterfaceTest = lazy(() => import("@/pages/interfaceTest/index"));
const InterfaceTestShare = lazy(
  () => import("@/pages/interfaceTest/index_pic"),
);

// RO质量平台
const RO = lazy(() => import("@/pages/RO/index"));
const ROshare = lazy(() => import("@/pages/RO/index_pic"));
const Logout = lazy(() => import("@/pages/Logout"));
// 证书管理
const CertDetail = lazy(() => import("@/pages/appStoreReview/apple/Certs"));

// 应用商店推荐
const AppStoreOverview = lazy(
  () => import("@/pages/appStoreRecommend/Overview"),
);
const AppStoreApple = lazy(() => import("@/pages/appStoreRecommend/Apple"));
const AppStoreGoogle = lazy(() => import("@/pages/appStoreRecommend/Google"));

const QAReviewOverview = lazy(
  () => import("@/pages/appStoreReview/AllOverview"),
);

const OnLineStatus = lazy(() => import("@/pages/OnlineStatus"));

// 应用商店审核/google/IAP
const GPIAP = lazy(() => import("@/pages/appStoreReview/google/IAP"));
// 应用商店审核/Apple/IAP
const IAP = lazy(() => import("@/pages/appStoreReview/apple/IAP"));
const IAPDetail = lazy(() => import("@/pages/appStoreReview/apple/IAP/Detail"));

// 应用商店审核/GooglePlay
const GoogleOverview = lazy(
  () => import("@/pages/appStoreReview/google/Overview"),
);
// 应用商店审核/Apple
const AppleOverview = lazy(
  () => import("@/pages/appStoreReview/apple/Overview"),
);

// 应用商店审核/Apple/自助扫描
const AppleRevealScan = lazy(
  () => import("@/pages/appStoreReview/apple/RevealScan"),
);

// 应用商店审核/Apple/外部分享

const ExternalFlowScan = lazy(
  () => import("@/pages/appStoreReview/apple/ExternalFlowScan"),
);

// 应用商店审核/Google/自助扫描
const GoogleRevealScan = lazy(
  () => import("@/pages/appStoreReview/google/RevealScan"),
);

const GoogleExternalFlowScan = lazy(
  () => import("@/pages/appStoreReview/google/ExternalFlowScan"),
);

// 应用商店审核/外部TF
const ExternalTF = lazy(() => import("@/pages/externalTF/externalFormContent"));
const GoogleAdd = lazy(() => import("@/pages/appStoreReview/google/Add"));
const AppleAdd = lazy(() => import("@/pages/appStoreReview/apple/Add"));
const GoogleDetail = lazy(() => import("@/pages/appStoreReview/google/Detail"));
const AppleDetail = lazy(
  () => import("@/pages/appStoreReview/apple/Detail/ios-detail"),
);

// 测试管理/质量看板
const QualityDashboard = lazy(() => import("@/pages/QualityDashboard"));

// 发行测试/人力视图
const Schedule = lazy(() => import("@/pages/releaseTest/schedule"));

// 我的项目
const MyProject = lazy(() => import("@/pages/myProject"));

// 发现测试2.0  (测试任务列表)
const TransferSheet = lazy(
  () => import("@/pages/TransferSheet/testTask/testTaskList"),
);

// 测试用例
const TestCase = lazy(() => import("@/pages/TestCase/index"));

// 测试计划-关联用例
const BoundCase = lazy(() => import("@/pages/TaskTestCase/BoundCase"));

// 创建测试用例集
const CreateUseCases = lazy(() => import("@/pages/TestCase/CreateUseCases"));

// 添加测试任务
const TestTaskNewAdd = lazy(
  () => import("@/pages/TransferSheet/testTask/TestTaskNewAdd"),
);

const TestTransferTask = lazy(
  () => import("@/pages/TransferSheet/transferSurvey/testTransferSheetList"),
);
// 创建转测单
const NewTestTransferSheet = lazy(
  () =>
    import("@/pages/TransferSheet/transferSurvey/Detail/newTestTransferSheet"),
);
// 转测单详情
const TestTicketDetail = lazy(
  () => import("@/pages/TransferSheet/transferSurvey/Detail/testTicketDetail"),
);
// 项目详情
const ProjectDetail = lazy(() => import("@/pages/projectDetail"));

// 项目设置
const Setting = lazy(() => import("@/pages/projectDetail/index"));

// 申请新项目
const NewProject = lazy(() => import("@/pages/newProject"));

// 编辑项目
const EditProject = lazy(() => import("@/pages/newProject"));

// 测试包管理
const wrapManage = lazy(() => import("@/pages/testPackageManagement"));

// 产出文档
const testReport = lazy(() => import("@/pages/TestReports"));

// QA周会
const QaWeekly = lazy(() => import("@/pages/QaWeekly/index"));

/** bpo工作量数据统计**/
const BpoWorkLoad = lazy(
  () => import("@/pages/WorkLoadManage/BpoWorkLoad/index"),
);

/** bpo工作量录入**/
const BpoDataEntry = lazy(() => import("@/pages/WorkLoadManage/DataEntry"));

// 工单系统
const WorkOrder = lazy(() => import("@/pages/WorkOrder"));

// 项目进度与风险
const ProjectProgress = lazy(() => import("@/pages/ProjectProgress"));

// 外不用户邮箱绑定【已经有了邮箱的用户，进行换邮箱的操作】
const Personal = lazy(() => import("@/pages/AppiyMail"));

// 权限管理
const RolePermissions = lazy(() => import("@/pages/RolePermissions"));
const RolePermissionsApply = lazy(
  () => import("@/pages/RolePermissions/RolePermissionsApply"),
);

// 苹果后台用户权限展示
const AppleStoreUsers = lazy(() => import("@/pages/AppleStoreUsers"));

// 谷歌后台用户权限展示
const GooglePlayUsers = lazy(() => import("@/pages/GooglePlayUsers"));

// lark 通知重定向 【【应用商店推荐专用】】
const Redirect = lazy(() => import("@/pages/Redirect"));

// lark 通知重定向 【ios、转测单、GooglePlay】
const LarkNoticeTransit = lazy(() => import("@/pages/LarkNoticeTransit"));

// 登录页面
const Login = lazy(() => import("@/pages/Login"));

// 质量日报
const QualityDaily = lazy(() => import("@/pages/QualityDaily"));
// 包体下载
const Download = lazy(() => import("@/pages/PackageDownload"));

// 线上问题管理
const IssuePlatform = lazy(() => import("@/pages/IssuePlatform/Overview"));
const IssueStats = lazy(() => import("@/pages/IssuePlatform/Statistics"));
const IssueHierarchy = lazy(() => import("@/pages/IssuePlatform/Hierarchy"));
const IssueProcess = lazy(() => import("@/pages/IssuePlatform/Process"));

// 运维发布
const GameOperation = lazy(() => import("@/pages/TransferSheet/GameOperation"));

// 转测单的测试报告
const TransferOrderTestReport = lazy(
  () => import("@/pages/TransferSheet/testReport/transferOrder/index"),
);

// 转测单的测试计划
const TransferTaskTestPlan = lazy(
  () => import("@/pages/TransferSheet/TestPlan/testPlan"),
);

// 转测任务的测试报告
const TransferTaskTestReport = lazy(
  () => import("@/pages/TransferSheet/testReport/transferTestTask/index"),
);

// 上线质量标准-执行标准
const ExecutiveStandard = lazy(
  () => import("@/pages/QualityStandard/ExecutiveStandard/index"),
);

// 上线质量标准-重定向页面
const ExecutiveStandardRedirect = lazy(
  () => import("@/pages/QualityStandard/ExecutiveStandard/Redirect"),
);

const AdministratorOverview = lazy(
  () => import("@/pages/QualityStandard/AdministratorModule/index"),
);

const HistoricalIssues = lazy(
  () => import("@/pages/QualityStandard/AdministratorModule/HistoricalIssues"),
);
const QualityStandard = lazy(
  () => import("@/pages/QualityStandard/AdministratorModule/QualityStandard"),
);

// 上线大盘
const OnlineMarket = lazy(() => import("@/pages/OnlineMarket/index"));

/** 测试任务的执行用例 */
const ExecuteUseCase = lazy(
  () => import("@/pages/TaskTestCase/ExecuteUseCase/index"),
);

// 工具箱 - 加固
const ProtectionOverview = lazy(
  () => import("@/pages/ToolBox/ProtectionCheck/index"),
);
const ProtectionTaskResult = lazy(
  () => import("@/pages/ToolBox/ProtectionCheck/ProtectionTaskResult"),
);
// 渠道检查
const StaticChannel = lazy(
  () => import("@/pages/StaticChannelInspection/index"),
);
const StaticChannelDetail = lazy(
  () => import("@/pages/StaticChannelInspection/ChannelInspectionResults"),
);
// GM指令
const GMConfig = lazy(() => import("@/pages/ToolBox/GM/index"));

/** bug管理的分享页面 */
const ShareBugBindPage = lazy(() => import("@/pages/BugBind/ShareBugPage"));

/** 隐私合规检查 */
const PrivacyCheck = lazy(() => import("@/pages/ToolBox/PrivacyCheck/index"));

/** 隐私合规报告 */
const PrivacyReport = lazy(
  () => import("@/pages/ToolBox/PrivacyCheck/PrivacyReport"),
);

/** 证书管理页 */
const CertsManagement = lazy(() => import("@/pages/CertsManagement"));
/** 证书管理详情页 */
const CertDetailPage = lazy(() => import("@/pages/CertsManagement/DetailPage"));

/** 测试覆盖率 */
const CodeCoverage = lazy(() => import("@/pages/ToolBox/CodeCoverage"));

/** 测试覆盖率详情页 */
const CoverageDetail = lazy(
  () => import("@/pages/ToolBox/CodeCoverage/CoverageDetail"),
);

export interface RouteConfigItem {
  key: string;
  path: string;
  component?: any;
  exact?: boolean;
  childrens?: Array<RouteConfigItem>;
  requiredPermissions?: Array<string>;
  render?: any;
}

/** 无须登录就能访问的路径 */
export const routesNoNeedLogin = [
  "/goto",
  "/redirect",
  "/login",
  "/personal-information",
  "/signout",
  "/apply-mail",
  "/guide",
  "/terms",
  "/privacy-policy",
  "/noPermission/download",
  "/bTest/releaseTesting/surveyNote/surveyNoteDetails",
  "/bTest/appStoreReview/tickets/details",
  "/shareBugBind",
];

const routerConfig: RouteConfigItem[] = [
  {
    path: "/login",
    key: "login",
    component: Login,
  },
  {
    key: "Download",
    path: "/download",
    component: Download,
  },
  {
    key: "NoPermissionDownload",
    path: "/noPermission/download",
    component: Download,
  },
  {
    key: "issuePlatform",
    path: "/issues",
    requiredPermissions: ["internal"],
    childrens: [
      {
        key: "overview",
        path: "/overview",
        component: IssuePlatform,
        exact: true,
      },
      {
        key: "process",
        path: "/process/:issueId",
        component: IssueProcess,
      },
      {
        key: "stats",
        path: "/stats",
        component: IssueStats,
      },
      {
        key: "hierarchy",
        path: "/hierarchy",
        component: IssueHierarchy,
      },
    ],
  },
  // FIXME:提审部分lark重定向【先把老的代码换成react等陆良俊重构完成在对一下逻辑】start
  {
    path: "/goto/appStoreReviewTicketDetail/:id", // lark 通知重定向
    key: "larkNoticeTransitAppStoreReview",
    component: LarkNoticeTransit,
  },
  {
    path: "/goto/qaTestDetail/:id",
    key: "larkNoticeTransitQaTestDetail",
    component: LarkNoticeTransit,
  },
  {
    path: "/bTest/releaseTesting/surveyNote/surveyNoteDetails",
    key: "larkNoticeTransitOldQaTestDetail",
    component: LarkNoticeTransit,
  },
  {
    path: "/bTest/appStoreReview/tickets/details/:id",
    key: "larkNoticeTransitOldAppStoreReview",
    component: LarkNoticeTransit,
  },
  {
    path: "/goto/googlePlay/detail/:id",
    key: "larkNoticeTransitOldGooglePlayReview",
    component: LarkNoticeTransit,
  },
  // FIXME:提审部分lark重定向【先把老的代码换成react等陆良俊重构完成在对一下逻辑】end
  {
    key: "redirect", // lark 通知重定向 【【应用商店推荐专用】】
    path: "/redirect",
    component: Redirect,
  },
  {
    key: "PermissionsApplyTicket",
    path: "/role-permissions-apply/:projectID/:role/:ticketID", // 申请权限
    component: RolePermissionsApply,
  },
  {
    key: "PermissionsApply",
    path: "/role-permissions-apply/:projectID/:role", // 申请权限
    component: RolePermissionsApply,
  },
  {
    key: "addPrivilegeManagement",
    path: "/privilegeManagement/addPrivilegeManagement", // 权限管理
    component: RolePermissions,
  },
  {
    key: "appStoreUserList",
    path: "/appStoreUserManagement/list", // 权限管理
    component: AppleStoreUsers,
  },
  {
    key: "googlePlayUserList",
    path: "/googlePlayUserManagement/list", // 权限管理
    component: GooglePlayUsers,
  },
  {
    key: "onLineStatusList",
    path: "/onlinestatus/list/:storetype", // 权限管理
    requiredPermissions: ["internal"],
    component: OnLineStatus,
  },
  {
    key: "allQAReviewList",
    path: "/allqareviewing/list", // 权限管理
    requiredPermissions: ["internal"],
    component: QAReviewOverview,
  },
  {
    key: "PersonalInformation", // 外部lark什申请mail 【已经有了邮箱要换新的邮箱】
    path: "/personal-information",
    component: Personal,
  },
  {
    key: "logout",
    path: "/signout",
    component: Logout,
  },
  {
    key: "myProject",
    path: "/my-project",
    component: MyProject,
  },
  {
    key: "ProjectDetail",
    path: "/:projectID/project-detail",
    requiredPermissions: ["internal", "external"],
    component: ProjectDetail,
  },
  {
    key: "Setting",
    path: "/:projectID/setting",
    requiredPermissions: ["internal", "external"],
    component: Setting,
  },
  {
    key: "NewProject",
    path: "/new-project",
    requiredPermissions: ["internal"],
    component: NewProject,
  },
  {
    key: "EditProject",
    requiredPermissions: ["internal"],
    path: "/:projectID/edit-project/:type",
    component: EditProject,
  },
  {
    key: "WorkOrder",
    path: "/work-order",
    component: WorkOrder,
  },
  {
    key: "CertsMng",
    path: "/certs-management",
    childrens: [
      {
        key: "CertsManagement",
        path: "/overview",
        component: CertsManagement,
        exact: true,
      },
      {
        key: "CertDetail",
        path: "/detail/:teamName",
        component: CertDetailPage,
      },
    ],
  },
  {
    key: "ProjectProgress",
    path: "/project-progress",
    component: ProjectProgress,
  },
  {
    key: "ReviewScanReport",
    path: "/scan-report",
    // requiredPermissions: ['internal'],
    childrens: [
      {
        key: "externalScan",
        path: "/external-scan/:projectID/:ticketID",
        component: ExternalFlowScan,
      },
      {
        key: "externalFlowScan",
        path: "/external-flow-scan/:projectID/:ticketID",
        component: ExternalFlowScan,
      },
      {
        key: "externalGoogleScan",
        path: "/external-google-scan/:projectID/:ticketID",
        component: GoogleExternalFlowScan,
      },
      {
        key: "externalGoogleFlowScan",
        path: "/external-googleFlow-scan/:projectID/:ticketID",
        component: GoogleExternalFlowScan,
      },
      {
        key: "googleInternalScan",
        path: "/:projectID/review/google/internal-scan/:ticketID",
        component: GoogleExternalFlowScan,
        exact: true,
      },
      {
        key: "googleInternalFlowScan",
        path: "/:projectID/review/google/internal-flow-scan/:ticketID",
        component: GoogleExternalFlowScan,
        exact: true,
      },
      {
        key: "internalAppleScan",
        path: "/:projectID/review/apple/internal-scan/:ticketID",
        component: ExternalFlowScan,
        exact: true,
      },
      {
        key: "internalFlowScan",
        path: "/:projectID/review/apple/internal-flow-scan/:ticketID",
        component: ExternalFlowScan,
        exact: true,
      },
    ],
  },
  {
    key: "googleiap",
    path: "/:projectID/review/google/iap",
    requiredPermissions: ["internal", "external"],
    component: GPIAP,
    exact: true,
  },
  {
    key: "appStoreReviewApple",
    path: "/:projectID/review/apple",
    childrens: [
      {
        key: "overview",
        path: "/",
        requiredPermissions: ["internal", "external"],
        component: AppleOverview,
        exact: true,
      },
      {
        key: "add",
        path: "/add",
        requiredPermissions: ["internal", "external"],
        component: AppleAdd,
      },
      {
        key: "edit",
        path: "/edit/:id",
        component: AppleAdd,
      },
      {
        key: "overview",
        path: "/iap",
        requiredPermissions: ["internal", "external"],
        component: IAP,
        exact: true,
      },
      {
        key: "detail",
        path: "/iap/:id",
        requiredPermissions: ["internal", "external"],
        component: IAPDetail,
      },
      {
        key: "revealScan",
        path: "/reveal-scan",
        component: AppleRevealScan,
        exact: true,
      },
      {
        key: "reviewDetail",
        path: "/:id",
        requiredPermissions: ["internal", "external"],
        component: AppleDetail,
        exact: true,
      },
    ],
  },
  {
    key: "externalTF",
    path: "/:projectID/review/externalTF",
    requiredPermissions: ["internal"],
    component: ExternalTF,
  },
  {
    key: "protection",
    path: "/:projectID/protection",
    childrens: [
      {
        key: "protectionOverview",
        path: "/",
        component: ProtectionOverview,
        exact: true,
      },
      {
        key: "protectionTask",
        path: "/:taskID",
        component: ProtectionTaskResult,
        exact: true,
      },
    ],
  },
  {
    key: "operationManagement",
    path: "/:projectID/operationManagement",
    requiredPermissions: ["internal", "external"],
    childrens: [
      {
        key: "ro",
        path: "/ro",
        component: RO,
        exact: true,
      },
      {
        key: "roShare",
        path: "/ro/preview/:year/:month",
        component: ROshare,
        exact: true,
      },
      {
        key: "qualityDashboard",
        path: "/quality-dashboard",
        component: QualityDashboard,
        exact: true,
      },
      {
        key: "gameOperation",
        path: "/gameOperation",
        component: GameOperation,
        exact: true,
      },
      {
        // 运营日报
        key: "QualityDaily",
        path: "/quality-daily/:report_id/:type/:range",
        requiredPermissions: ["internal", "external"],
        component: QualityDaily,
        exact: true,
      },
      {
        // 运营周报
        key: "QualityWeekly",
        path: "/quality-weekly/:report_id/:type/:range",
        requiredPermissions: ["internal", "external"],
        component: QualityDaily,
        exact: true,
      },
      {
        key: "QualityDaily",
        path: "/quality-daily/:report_id/:type/:range/:pagetype",
        requiredPermissions: ["internal", "external"],
        component: QualityDaily,
        exact: true,
      },
      {
        key: "QualityWeekly",
        path: "/quality-weekly/:report_id/:type/:range/:pagetype",
        requiredPermissions: ["internal", "external"],
        component: QualityDaily,
        exact: true,
      },
      // 记录抽屉是否打开
      {
        key: "QualityDaily",
        path: "/quality-daily/:report_id/:type/:range/:pagetype/:status",
        component: QualityDaily,
        exact: true,
      },
      {
        key: "QualityWeekly",
        path: "/quality-weekly/:report_id/:type/:range/:pagetype/:status",
        component: QualityDaily,
        exact: true,
      },
      {
        key: "overview",
        path: "/issues/overview",
        requiredPermissions: ["internal"],
        component: IssuePlatform,
        exact: true,
      },
      {
        key: "process",
        path: "/issues/process/:issueId",
        requiredPermissions: ["internal"],
        component: IssueProcess,
        exact: true,
      },
      {
        key: "stats",
        path: "/issues/stats",
        requiredPermissions: ["internal"],
        component: IssueStats,
        exact: true,
      },
      {
        key: "hierarchy",
        path: "/issues/hierarchy",
        requiredPermissions: ["internal"],
        component: IssueHierarchy,
        exact: true,
      },
      {
        key: "ExecutiveStandard",
        path: "/standard/:type/:period",
        requiredPermissions: ["internal"],
        component: ExecutiveStandard,
        exact: true,
      },
    ],
  },
  {
    key: "storeManagement",
    path: "/:projectID/storeManagement",
    // requiredPermissions: ['internal',"project_bpo_tester"],
    childrens: [
      {
        key: "appStoreReviewIos",
        path: "/ios",
        childrens: [
          {
            key: "overview",
            path: "/",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: AppleOverview,
            exact: true,
          },
          {
            key: "add",
            path: "/add",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: AppleAdd,
          },
          {
            key: "edit",
            path: "/edit/:id",
            requiredPermissions: ["internal"],
            component: AppleAdd,
          },
          {
            key: "detail",
            path: "/iap/:id",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: IAPDetail,
          },
          {
            key: "revealScan",
            path: "/reveal-scan",
            component: AppleRevealScan,
            exact: true,
          },
          {
            key: "reviewDetail",
            path: "/:id",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: AppleDetail,
            exact: true,
          },
        ],
      },
      {
        key: "externalTF",
        path: "/externalTF",
        requiredPermissions: ["internal"],
        component: ExternalTF,
      },
      {
        key: "appStoreReviewGoogle",
        path: "/google",
        childrens: [
          {
            key: "overview",
            path: "/",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: GoogleOverview,
            exact: true,
          },
          {
            key: "add",
            path: "/add",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: GoogleAdd,
          },
          {
            key: "edit",
            path: "/edit/:id",
            requiredPermissions: ["internal"],
            component: GoogleAdd,
          },
          {
            key: "revealScan",
            path: "/reveal-scan",
            component: GoogleRevealScan,
          },
          {
            key: "detail",
            path: "/:id",
            requiredPermissions: ["internal", "project_bpo_tester"],
            component: GoogleDetail,
          },
        ],
      },
    ],
  },
  {
    key: "testManagement",
    path: "/:projectID/testManagement",
    childrens: [
      {
        key: "schedule",
        path: "/schedule",
        component: Schedule,
        exact: true,
      },
      {
        // 多条用例
        key: "multipleUseCases",
        path: "/multipleUseCases/:type/:folderName/:folderID/:docLink",
        component: CreateUseCases,
        exact: true,
      },
      {
        // 创建用例集
        key: "createUseCaseSet",
        path: "/createUseCaseSet/:type/:folderName/:folderID/:docLink",
        component: CreateUseCases,
        exact: true,
      },
      {
        key: "transferOrder",
        path: "/transferOrder",
        childrens: [
          {
            key: "list",
            path: "/",
            component: TestTransferTask,
            exact: true,
          },
          // {
          //   key: 'detail',
          //   path: '/:id',
          //   component: TestTransferTask,
          //   exact: true,
          // },
          {
            key: "add",
            path: "/add",
            requiredPermissions: ["internal", "external"],
            component: NewTestTransferSheet,
            exact: true,
          },
          {
            key: "edit",
            path: "/edit/:ticketID",
            component: NewTestTransferSheet,
            exact: true,
          },
          {
            key: "detail",
            path: "/detail/:ticketID",
            component: TestTicketDetail,
            exact: true,
          },
          {
            // 转测单的测试报告
            key: "report",
            path: "/report/:ticketID",
            component: TransferOrderTestReport,
            exact: true,
          },
          {
            // 测试计划
            key: "testPlan",
            path: "/plan/:ticketID",
            component: TransferTaskTestPlan,
            exact: true,
          },
        ],
      },
      {
        key: "transferTask",
        path: "/transferTask",
        childrens: [
          {
            key: "list",
            path: "/",
            component: TransferSheet,
            exact: true,
          },
          {
            key: "detail",
            path: "/:id",
            component: TransferSheet,
            exact: true,
          },
          {
            key: "add",
            path: "/add/:ticketID",
            requiredPermissions: ["internal", "external"],
            component: TestTaskNewAdd,
            exact: true,
          },
          {
            key: "BoundCase",
            path: "/boundCase/:taskID/:subTaskID",
            component: BoundCase,
            exact: true,
          },
          {
            key: "BoundCase",
            path: "/boundCase/:taskID",
            component: BoundCase,
            exact: true,
          },
          {
            // 转测任务的测试报告
            key: "report",
            path: "/report/:taskID",
            component: TransferTaskTestReport,
            exact: true,
          },
        ],
      },
      {
        key: "testCase",
        path: "/testCase",
        component: TestCase,
        exact: true,
      },
      {
        key: "testPackage",
        path: "/wrapManage",
        component: wrapManage,
        exact: true,
      },
      {
        key: "testReport",
        path: "/testReport",
        component: testReport,
        exact: true,
      },
    ],
  },
  {
    key: "reSignPackage",
    path: "/:projectID/hold-all/re-sign-package", // 工具箱的重签包管理页面
    component: wrapManage,
    exact: true,
  },
  {
    key: "codeCoverage",
    path: "/:projectID/code-coverage", // 工具箱的重签包管理页面
    childrens: [
      {
        key: "list",
        path: "/",
        component: CodeCoverage,
        exact: true,
      },
      {
        key: "detail",
        path: "/detail/:version",
        component: CoverageDetail,
        exact: true,
      },
    ],
  },
  {
    key: "interfaceTest",
    path: "/:projectID/interfacetest", // 接口自动化页面
    component: InterfaceTest,
    exact: true,
  },
  {
    key: "interfaceTest",
    path: "/:projectID/interfacetest/:timestamp", // 接口自动化页面
    component: InterfaceTest,
    exact: true,
  },
  {
    key: "interfaceTest",
    path: "/:projectID/interfacetest/sh/:timestamp", // 接口自动化页面
    component: InterfaceTestShare,
    exact: true,
  },
  {
    key: "gmConfig",
    path: "/:projectID/gm-config", // gm管理页面
    // requiredPermissions: ['bpo'],
    component: GMConfig,
    exact: true,
  },
  {
    key: "qualityDashboard",
    path: "/:projectID/quality-dashboard",
    component: QualityDashboard,
  },
  {
    key: "releaseTest",
    path: "/:projectID/releaseTest",
    childrens: [
      {
        key: "gameOperation",
        path: "/gameOperation",
        component: GameOperation,
        exact: true,
      },
      {
        key: "schedule",
        path: "/schedule",
        component: Schedule,
        exact: true,
      },
      {
        // 多条用例
        key: "multipleUseCases",
        path: "/multipleUseCases/:type/:folderName/:folderID/:docLink",
        component: CreateUseCases,
        exact: true,
      },
      {
        // 创建用例集
        key: "createUseCaseSet",
        path: "/createUseCaseSet/:type/:folderName/:folderID/:docLink",
        component: CreateUseCases,
        exact: true,
      },
      {
        key: "transferOrder",
        path: "/transferOrder",
        childrens: [
          {
            key: "list",
            path: "/",
            component: TestTransferTask,
            exact: true,
          },
          {
            key: "detail",
            path: "/:id",
            component: TestTransferTask,
            exact: true,
          },
        ],
      },
      {
        key: "transferTask",
        path: "/transferTask",
        childrens: [
          {
            key: "list",
            path: "/",
            component: TransferSheet,
            exact: true,
          },
          {
            key: "detail",
            path: "/:id",
            component: TransferSheet,
            exact: true,
          },
          {
            key: "add",
            path: "/add/:ticketID",
            requiredPermissions: ["internal", "external"],
            component: TestTaskNewAdd,
            exact: true,
          },
          {
            key: "BoundCase",
            path: "/boundCase/:taskID",
            component: BoundCase,
            exact: true,
          },
          {
            key: "BoundCase",
            path: "/boundCase/:taskID/:subTaskID",
            component: BoundCase,
            exact: true,
          },
        ],
      },
      {
        key: "newTransferOrder",
        path: "/newTransferOrder",
        childrens: [
          {
            key: "add",
            path: "/",
            component: NewTestTransferSheet,
            exact: true,
          },
          {
            key: "detail",
            path: "/:ticketID",
            component: NewTestTransferSheet,
            exact: true,
          },
        ],
      },
      {
        key: "transferOrderDetail",
        path: "/transferOrderDetail/:ticketID",
        component: TestTicketDetail,
        exact: true,
      },
      {
        // 转测任务的测试报告
        key: "transferTaskTestReport",
        path: "/transferTaskTestReport/:taskID",
        component: TransferTaskTestReport,
        exact: true,
      },
      {
        // 转测单的测试报告
        key: "transferOrderTestReport",
        path: "/transferOrderTestReport/:ticketID",
        component: TransferOrderTestReport,
        exact: true,
      },
    ],
  },
  {
    key: "testCase",
    path: "/:projectID/testCase",
    component: TestCase,
    exact: true,
  },
  {
    key: "testPackage",
    path: "/:projectID/wrapManage",
    component: wrapManage,
    exact: true,
  },
  {
    // 运营日报
    key: "QualityDaily",
    path: "/:projectID/quality-daily/:report_id/:type/:range",
    requiredPermissions: ["internal"],
    component: QualityDaily,
    exact: true,
  },
  {
    // 运营周报
    key: "QualityWeekly",
    path: "/:projectID/quality-weekly/:report_id/:type/:range",
    requiredPermissions: ["internal"],
    component: QualityDaily,
    exact: true,
  },
  {
    key: "QualityDaily",
    path: "/:projectID/quality-daily/:report_id/:type/:range/:pagetype",
    component: QualityDaily,
    exact: true,
  },
  {
    key: "QualityWeekly",
    path: "/:projectID/quality-weekly/:report_id/:type/:range/:pagetype",
    component: QualityDaily,
    exact: true,
  },
  // 记录抽屉是否打开
  {
    key: "QualityDaily",
    path: "/:projectID/quality-daily/:report_id/:type/:range/:pagetype/:status",
    component: QualityDaily,
    exact: true,
  },
  {
    key: "QualityWeekly",
    path: "/:projectID/quality-weekly/:report_id/:type/:range/:pagetype/:status",
    component: QualityDaily,
    exact: true,
  },
  {
    key: "onlineQualityStandards",
    path: "/online-quality",
    requiredPermissions: ["internal"],
    childrens: [
      {
        // 质量标准--管理员模块--默认页面(Overview总览页面)
        key: "OnlineQualityOverview",
        path: "/",
        component: AdministratorOverview,
        exact: true,
      },
      {
        // 质量标准--管理员模块--质量标准页面
        key: "QualityStandard",
        path: "/standard",
        component: QualityStandard,
        exact: true,
      },
      {
        // 质量标准--管理员模块--历史问题经验库页面
        key: "HistoricalIssues",
        path: "/historical-issues",
        component: HistoricalIssues,
        exact: true,
      },
    ],
  },
  {
    key: "ExecutiveStandard",
    path: "/:projectID/standard/:type/:period",
    component: ExecutiveStandard,
    exact: true,
  },
  {
    key: "ExecutiveStandardRedirect",
    path: "/:projectID/:period/executive-standard",
    component: ExecutiveStandardRedirect,
    exact: true,
  },
  {
    key: "OnlineMarket",
    path: "/online-market",
    requiredPermissions: ["internal"],
    component: OnlineMarket,
  },
  // TODO: 这部分还没测通
  {
    key: "appStoreReviewGoogle",
    path: "/:projectID/review/google",
    childrens: [
      {
        key: "overview",
        path: "/",
        requiredPermissions: ["internal"],
        component: GoogleOverview,
        exact: true,
      },
      {
        key: "add",
        path: "/add",
        requiredPermissions: ["internal"],
        component: GoogleAdd,
      },
      {
        key: "edit",
        path: "/edit/:id",
        component: GoogleAdd,
      },
      {
        key: "revealScan",
        path: "/reveal-scan",
        component: GoogleRevealScan,
      },
      {
        key: "detail",
        path: "/:id",
        requiredPermissions: ["internal"],
        component: GoogleDetail,
      },
    ],
  },
  {
    key: "appStoreRecommend",
    path: "/:projectID/recommend",
    requiredPermissions: ["internal"],
    childrens: [
      {
        key: "overview",
        path: "/",
        component: AppStoreOverview,
        exact: true,
      },
      {
        key: "apple",
        path: "/apple",
        component: AppStoreApple,
      },
      {
        key: "google",
        path: "/google",
        component: AppStoreGoogle,
      },
    ],
  },
  {
    key: "certManage",
    path: "/:projectID/certManage",
    requiredPermissions: ["internal", "external"],
    component: CertDetail,
  },
  /** 数据概览 */
  {
    key: "qa-weekly",
    path: "/qa-weekly",
    requiredPermissions: ["internal"],
    component: QaWeekly,
  },
  /** 工作量统计 */
  {
    key: "workload",
    path: "/workload",
    childrens: [
      {
        key: "overview",
        path: "/bpo-overview",
        requiredPermissions: ["internal"],
        component: BpoWorkLoad,
        exact: true,
      },
      {
        key: "bpo-data-entry",
        path: "/bpo-data-entry",
        component: BpoDataEntry,
      },
    ],
  },
  /** 测试计划的执行用例 */
  /** 测试计划的执行用例---子任务 */
  {
    key: "executeUseCase",
    path: "/execute-usecase/:projectID/:taskID/:subTaskID",
    component: ExecuteUseCase,
    exact: true,
  },
  /** 测试计划的执行用例---父任务 */
  {
    key: "executeUseCase",
    path: "/execute-usecase/:projectID/:taskID",
    component: ExecuteUseCase,
    exact: true,
  },
  /** 静态渠道检查 */
  {
    key: "staticChannel",
    path: "/:projectID/package-inspection/static-channel",
    component: StaticChannel,
    exact: true,
  },
  {
    key: "staticChannel",
    path: "/:projectID/package-inspection/static-channel/:channelTaskId",
    component: StaticChannelDetail,
    exact: true,
  },
  /** bug管理的分享页面 */
  {
    key: "shareBugBind",
    path: "/:projectID/shareBugBind/:taskID/:ticketID",
    component: ShareBugBindPage,
    exact: true,
  },
  /** 隐私合规检查 */
  {
    key: "privacyCheck",
    path: "/:projectID/privacy-scan",
    component: PrivacyCheck,
    exact: true,
  },
  /** 隐私合规检查报告 */
  {
    key: "privacyCheck",
    path: "/:projectID/privacy-scan/report",
    component: PrivacyReport,
    // exact: true,
  },
];

const routeRender = (
  config: RouteConfigItem[],
  userType: string,
  parentPath?: string,
) => {
  const routes: JSX.Element[] = [];
  for (const item of config) {
    const {
      key,
      path,
      component,
      requiredPermissions,
      exact = false,
      childrens,
    } = item;
    const Component =
      component || (({ children }) => <Switch>{children}</Switch>);
    let modulePath: string;
    if (!parentPath || parentPath === "/") {
      modulePath = path;
    } else if (path === "/") {
      modulePath = parentPath;
    } else {
      modulePath = `${parentPath}${path}`;
    }
    if (Array.isArray(childrens) && childrens.length) {
      if (checkPermission(requiredPermissions, userType)) {
        // const newUserType=requiredPermissions?.includes("right_bpo_tester_operator")?"right_bpo_tester_operator":userType;
        // console.log(requiredPermissions,userType,"userType----")
        const children = routeRender(childrens, userType, modulePath);
        routes.push(
          <Route
            key={key}
            path={modulePath}
            exact={false}
            render={() => <Component>{children}</Component>}
          />,
        );
      } else {
        // console.log(2)
        // const children = routeRender(childrens, userType, modulePath);
        routes.push(
          <Route
            key={key}
            path={modulePath}
            exact={exact}
            render={() => (
              <Result
                status="403"
                subTitle={I18n.t("no_access_rights", {}, "暂无访问权限")}
              />
            )}
          />,
        );
      }
    } else {
      routes.push(
        checkPermission(requiredPermissions, userType) ? (
          <Route
            key={key}
            path={modulePath}
            exact={exact}
            component={Component}
          />
        ) : (
          <Route
            key={key}
            path={modulePath}
            exact={exact}
            render={() => (
              <Result
                status="403"
                subTitle={I18n.t("no_access_rights", {}, "暂无访问权限")}
              />
            )}
          />
        ),
      );
    }
  }
  return routes;
};

const checkPermission = (
  authType: string[] | undefined,
  curUserType: string,
) => {
  return authType ? authType.includes(curUserType) : true;
};

export const getRoutes = (userType: string) => {
  return routeRender(routerConfig, userType);
};
